import React from "react";
import { ToastContainer } from "react-toastify";

import GiftCardsList from "./components/GiftCardsList";

const GiftCardsApp = (props) => (
  <>
    <ToastContainer icon={false} />
    <GiftCardsList {...props} />
  </>
);

export default GiftCardsApp;
